module.exports = __webpack_public_path__ + "static/media/spinman-fly.b0c7116d.png";